import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Colors } from '@lichtblick/theme';
import { useTracker } from '@lichtblick/tracker';
import { Chip } from '../../atoms/Chip';
import { Headline } from '../../atoms/Headline';
import { Text } from '../../atoms/Text';
import { Container, Content, Media, StyledLink } from './TeaserItem.styles';
export const TeaserItem = ({ backgroundColor = Colors.White, children, chip, className, headline, isTextOutside = false, link, media, onClick, text, tracking })=>{
    const { trackCustomEvent } = useTracker();
    const trackEvent = (trackingData)=>{
        trackCustomEvent(trackingData);
        if (link?.href?.includes('onelink')) {
            trackCustomEvent({
                eventName: 'app_link',
                customProps: {
                    link_type: 'Onelink'
                }
            }, undefined, false);
        }
    };
    const content = /*#__PURE__*/ _jsxs(Content, {
        $isTextOutside: isTextOutside,
        children: [
            chip && /*#__PURE__*/ _jsx(Chip, {
                label: chip
            }),
            headline && /*#__PURE__*/ _jsx(Headline, {
                size: "S",
                children: headline
            }),
            text && /*#__PURE__*/ _jsx(Text, {
                children: text
            }),
            !isTextOutside && children
        ]
    });
    return /*#__PURE__*/ _jsxs(StyledLink, {
        $backgroundColor: backgroundColor,
        $isTextOutside: isTextOutside,
        className: className,
        "data-testid": "teaser-item",
        download: link?.isDownloadLink,
        href: link?.href ?? '#',
        onClick: (event)=>{
            trackEvent(tracking);
            onClick?.(event);
        },
        target: link?.shouldOpenInNewTab ? '_blank' : undefined,
        children: [
            /*#__PURE__*/ _jsxs(Container, {
                $backgroundColor: backgroundColor,
                $isTextOutside: isTextOutside,
                children: [
                    media && /*#__PURE__*/ _jsx(Media, {
                        $backgroundColor: backgroundColor,
                        $isTextOutside: isTextOutside,
                        children: media
                    }),
                    !isTextOutside && content
                ]
            }),
            isTextOutside && content
        ]
    });
};

//# sourceMappingURL=TeaserItem.js.map